const cidActions = {
  CID_FETCH_REQUEST: 'CID_FETCH_REQUEST',
  CID_FETCH_SUCCESS: 'CID_FETCH_SUCCESS',
  CID_FETCH_ERROR: 'CID_FETCH_ERROR',
  getCid: () => ({
    type: cidActions.CID_FETCH_REQUEST,
  }),
};
export default cidActions;
